import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useToast } from 'Components/Toast/useToast'

import { useStore } from 'Stores/index'

import { handleFetchErrorFunctional } from 'Utilities'

import { SentryErrorType } from 'Constants/errors'

type MutationErrorHandler = (
  error: Error,
  options?: { variables?: unknown },
) => void

export const useMutationErrorHandler = (): ((
  operationName: string,
  messageId: string,
) => MutationErrorHandler) => {
  const { showToast } = useToast()
  const { userStore } = useStore()
  const intl = useIntl()
  const userId = userStore.user.userId?.toString() ?? ''

  return useCallback(
    (operationName: string, messageId: string) =>
      (error: Error, options?: { variables?: unknown }) => {
        showToast({
          content: intl.formatMessage({ id: messageId }),
          variant: 'error',
        })
        handleFetchErrorFunctional()(error, {
          location: window?.location || undefined,
          operation: {
            operationName,
            variables: options?.variables,
          },
          type: SentryErrorType.GQL_ERROR,
          userId,
        })
      },
    [intl, showToast, userId],
  )
}
